import { useEffect, useCallback, useSyncExternalStore } from 'react';
import api from '../services/api';

// Preferencias de vista por usuario, persistidas en el servidor (user_prefs).
// Sobreviven refresh y sesiones, y son compartidas entre dispositivos.
// Cache de módulo + subscribers: todos los componentes que usan la misma clave
// se actualizan juntos (ej. colapsar Tareas en un día colapsa todos los días).

let cache = null;
let loadPromise = null;
const listeners = new Set();
const emit = () => listeners.forEach(l => l());

function ensureLoaded() {
  if (!loadPromise) {
    loadPromise = api.get('/prefs')
      .then(({ data }) => { cache = data && typeof data === 'object' ? data : {}; })
      .catch(() => { cache = {}; })
      .finally(emit);
  }
}

const subscribe = cb => { listeners.add(cb); return () => listeners.delete(cb); };

export default function usePref(key, defaultValue) {
  useEffect(ensureLoaded, []);

  const stored = useSyncExternalStore(
    subscribe,
    () => (cache && key in cache ? cache[key] : undefined)
  );

  const save = useCallback(value => {
    if (!cache) cache = {};
    cache[key] = value;
    emit();
    api.put('/prefs', { [key]: value }).catch(() => {});
  }, [key]);

  return [stored === undefined ? defaultValue : stored, save];
}
